<template>
    <div id="homeAppSum">
        <a-card title="应用统计">
            <msearch @searchChange="handleSearchChange" :onlyFlow="onlyFlow"></msearch>
            <mtable :searchD="searchD" :onlyFlow="onlyFlow" :style="{width:tableWidth}"></mtable>
            
        </a-card>

    </div>
</template>

<script>

import mtable from "../appsum/table"
import msearch from "../appsum/search"
export default {
    data(){
        return {
            searchD:{startTime:"",endTime:"",selectedAppcode:"",selectedInvokeappcode:"",searchTimeRange:"",dateTypeTitle:''},

            onlyFlow:2,
            tableWidth:'800px'

        }
    },
    methods:{
        handleSearchChange(d){
            this.searchD = d;
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
    components:{
        mtable,
        msearch
    }
};
</script>

<style lang="less" scoped>
</style>
<style>
  #homeAppSum .ant-card-body{
        padding-top: 0;
    }
</style>